import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

import { fetchAdvantages } from '../actions/advantageActions';

import { Jumbotron, ButtonGroup, Button, Tabs, Tab, Row, Col, Card, Image } from 'react-bootstrap';


class About extends Component {
    componentDidMount() {
        this.props.fetchAdvantages()
    }
    render () {
        const advantages = this.props.advantages.map(advantage => (
            <Col xs={12} md={4}>
                <Card className="m-2 p-2" key={advantage.id}>
                    <Card.Header>
                        <Row>
                            <Col xs={3}><Image src={`https://sinomost.kz${advantage.image}`} width="100%"></Image></Col>
                            <Col>
                                <Card.Title>{advantage.name}</Card.Title>
                            </Col>
                        </Row>
                    </Card.Header>
                    <Card.Body>
                        <Card.Text>
                            {advantage.html}
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
        ));
        return (
            <>
                <Helmet>
                    <meta charset="UTF-8" />
                    <title>ТОО "СИНОМОСТ" - О Конмпании. Команда. Преимущества.</title>
                    <meta name="description" content="Спецтехника и автомобили. Фронтальные погразчики, самосвалы, краны, бульдозеры, экскаваторы, асфальтоукладчики, рейдеры. Кроссоверы, Седаны, Внедорожники." />
                    <meta name="keywords" content="BAIC, Beijing, Senovo, Liugong, Lonking, Фронтальные погразчики, самосвалы, краны, бульдозеры, экскаваторы, асфальтоукладчики, рейдеры. Кроссоверы, Седаны, Внедорожники" />
                </Helmet>
                <Jumbotron>
                    <h1>ТОО "Синомост"</h1>
                    <p>Автомобили и Спецтехника от компании ТОО "Синомост" - гарантия качественной покупки техники. Вы получаете зоводскую гарантию абсолютно на все позиции. ТОО "Синомост" предоставляет сервис по на Автомобили и Спецтехнику. Так же, у нас Вы можете любую деталь и комплектующие, которые Вам могут пригодиться. Работая с заводом производителя на прямую, мы гарантируем Вам цены, которые приятно удивят. А налаженная система поставки позволит Вам купить любые объемы техники оптом и в розницу в максимально короткие сроки.</p>
                    <ButtonGroup>
                        <a href="https://wa.me/77015471529" target="_blank" className="btn btn-success">Написать в Whatsapp</a>
                        <a href="tel:+77015471529" className="btn btn-light">Позвонить</a>
                    </ButtonGroup>
                    <Tabs className="mt-4" defaultActiveKey="about" id="uncontrolled-tab-example">
                        <Tab eventKey="about" title="О нас">
                            <p className="lead p-2">ТОО "Синомост" является надежным поставщиком автомобилей и спецтехники уже более 8 лет! Мы работаем для Вас с 2014 года и обеспечиваем поставку качествой техникой по самым низким ценам на рынке. У нас всегда есть в наличии комплектующие на все виды техники. Мы проедоставляем гарантию от завода и занимаемся сервисным обслуживанием. Работая с нами, Вы всегда будете в выйгрыше.</p>
                            <Image src="https://sinomost.kz/media/about/company.jpg" alt="О компании Синомост" width="100%" className="m-auto"></Image>
                        </Tab>
                        <Tab eventKey="team" title="Команда">
                            <p className="lead p-2">Наша обширная команда специалистов трудится чтобы обеспечить комфортные условия покупки и предоставить любую необходимую информация. Вы можете спросить о любой интересующей Вас технике у наших специалистов прямо сейчас.
                                У нас так же работает большая компанда ремонтников, только для обеспечения сервиса технике поставляемой нашей компанией.</p>
                            <Image src="https://sinomost.kz/media/about/team.jpg" alt="Комадна компании Синомост" width="100%" className="m-auto"></Image>
                        </Tab>
                        <Tab eventKey="profits" title="Почему мы">
                            <p className="lead p-2">Почему следует работать именно с нами? Мы расскажем Вам все о преимуществах и недостатках разных видов техники. Убедимся что Вы покупаете именно то, что Вам нужно. Вы получите нужную информацию о том, что Вас интересует и получите список техники, который Вам подойдет. Так же, мы готовы сделать Вас специальное, индивидуальное коммерческое предложение. Чтобы получить его, свяжитесь с нашими специалистами прямо сейчас.</p>
                            <Row className="mt-5 text-center">
                                <Col xs={12}>
                                    <Row>
                                        {advantages}
                                    </Row>
                                </Col>
                            </Row>
                        </Tab>
                    </Tabs>
                </Jumbotron>
            </>
        );
    };
};

const mapStateToProps = state => ({
    advantages: state.advantages.items,
});

export default connect(mapStateToProps, { fetchAdvantages })(About);
